import {
  bidSchema,
  type Bid,
  type BidDecisionInput,
  type BidListQuery,
  type Page,
  type SubmitBidInput,
} from '@teentack/shared';
import { apiFetch, post } from '@/lib/api-client';
import { fetchPage } from '@/lib/api-page';

/** The teen's own bids. */
export function fetchMyBids(query: Partial<BidListQuery> = {}): Promise<Page<Bid>> {
  return fetchPage('/bids/me', bidSchema, query);
}

/** Bids on the signed-in employer's jobs. */
export function fetchJobBids(query: Partial<BidListQuery> = {}): Promise<Page<Bid>> {
  return fetchPage('/bids', bidSchema, query);
}

export async function submitBid(input: SubmitBidInput): Promise<Bid> {
  return bidSchema.parse(await post<unknown>('/bids', input));
}

export async function withdrawBid(bidId: string): Promise<void> {
  await apiFetch<void>(`/bids/${bidId}`, { method: 'DELETE' });
}

export async function decideBid(bidId: string, input: BidDecisionInput): Promise<Bid> {
  return bidSchema.parse(await post<unknown>(`/bids/${bidId}/decision`, input));
}
